<div
  class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10"
  *transloco="let t; read: 'auth.recoverPassword'"
>
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />

  <h2 class="text-primary">{{ t('title') }}</h2>
  <div class="relative z-10">
    <div class="w-[640px] rounded-[5px] bg-white p-8">
      <app-password-reset-form
        [isLoading]="isLoading"
        (formSubmit)="onFormSubmit($event)"
      ></app-password-reset-form>
    </div>
  </div>

  <app-legal-links-container></app-legal-links-container>
</div>
